import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import english from './english';
import greek from './greek';
import { custom_translations } from "../../portal.custom.page.config";

i18n.use(LanguageDetector).init({
  // we init with resources
  lng: 'ENG',
  resources: {
    ENG: {
      translations: custom_translations && custom_translations.english && english ? {...english.english, ...custom_translations.english.english} : {...english.english}
    },
    GR: {
      translations: custom_translations && custom_translations.greek && custom_translations.greek.greek ? {...greek.greek, ...custom_translations.greek.greek} : {...greek.greek}
    }
  },
  fallbackLng: "ENG",
  debug: false,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",
  // allow keys to be phrases having `:`, `.`
  nsSeparator: false,
  keySeparator: false, // we use content as keys
  fallbackLng: false,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export const strings = {
  english,
  greek,
}

export default i18n;
